import { createFileRoute, redirect } from "@tanstack/react-router";

/** Facilities moved into the settings hub; the old address still works. */
export const Route = createFileRoute("/_authenticated/_administration/facilities")({
  beforeLoad: () => {
    throw redirect({ to: "/settings/facilities" });
  },
});
